<template>
  <a-modal
    v-model:open="visible"
    :title="i18n.$t('内容加载失败')"
    :width="480"
    :centered="true"
    :mask-closable="false"
    :closable="false"
  >
    <p>
      {{ i18n.$t("浏览器缓存原因，文件已失效，请刷新页面") }}
    </p>

    <template #footer>
      <a-button type="primary" @click="handleRefresh">
        {{ i18n.$t("刷新") }}
      </a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { useAsyncComponentVisible } from "@peerup/helper"
import { watch } from "vue"

import { i18n } from "@/plugins/i18n"
import $logger, { InfoAction } from "@/utils/logger"

const visible = useAsyncComponentVisible()

watch(visible, newVal => {
  if (newVal) {
    $logger.info(InfoAction.ASYNC_COMPONENT_REFRESH, {
      url: window.location.href,
    })
  }
})

const handleRefresh = () => {
  $logger.log("页面刷新", { msg: "异步组件加载失败，用户刷新页面" }, { immediate: true })
  // 强制刷新，清除缓存
  window.location.reload()
}
</script>
